module.exports = __webpack_public_path__ + "img/newtitle.90cfd56b.png";